import { queryKeys } from '../keys'
import { DEFAULT_RETRY_MUTATION } from '../config'
import type { QueryClient } from '@tanstack/react-query'
import { notificationService } from '@/services/notification'
import { NOTIFICATION_CATEGORY } from '@/utils/constant'

function mutatePostRead(queryClient: QueryClient) {
  queryClient.setMutationDefaults(queryKeys.notification.read(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (payload: Parameters<typeof notificationService.read>[0]) =>
      notificationService.read(payload),
    onMutate: async () => {
      await queryClient.cancelQueries({
        queryKey: queryKeys.notification.tabList(),
      })
      for (const [_, category] of Object.entries(NOTIFICATION_CATEGORY)) {
        await queryClient.cancelQueries({
          queryKey: queryKeys.notification.notifications({ category }),
          exact: true,
          type: 'active',
        })
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.notification.tabList(),
      })
      for (const [_, category] of Object.entries(NOTIFICATION_CATEGORY)) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.notification.notifications({ category }),
          exact: true,
          type: 'active',
        })
      }
    },
  })
}

export function registerNotificationMutations(queryClient: QueryClient) {
  mutatePostRead(queryClient)
}
